var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRealTimeNotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000133487110084842821980000012523315594366316940_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m415.8 74.1h-368.9c-25.9 0-46.9 21-46.9 46.9v233.5c0 25.9 21 46.9 46.9 46.9h27.2v88.4c0 7.6 6.2 13.8 13.8 13.8 3 0 6-1 8.4-2.8l130.3-99.4h189.2c25.9 0 46.9-21 46.9-46.9v-233.5c0-25.9-21-46.9-46.9-46.9z",
    fill: "#84c9fe"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396.8,
    cy: 123.5,
    fill: "#ff5364",
    r: 115.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m399.9 191.7c-4 0-7.2-3.2-7.2-7.2v-104.5l-27.5 27.5c-2.6 3-7.2 3.4-10.2.8s-3.4-7.2-.8-10.2c.2-.3.5-.5.8-.8l39.8-39.9c2.8-2.8 7.4-2.8 10.2 0 1.4 1.4 2.1 3.2 2.1 5.1v121.8c.1 4.1-3.2 7.4-7.2 7.4z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealTimeNotification);
export default __webpack_public_path__ + "static/media/real-time-notification.5d34322021b9f51387482ff6fe3b291b.svg";
export { ForwardRef as ReactComponent };